export default __webpack_public_path__ + "static/media/Silver.5e6c6cfa.svg";